<template>
  <div>
    The mean orbital elements restituted from the SP measurements are displayed
    in the "Plots" section along with their associated uncertainties. Please
    note, that these orbits correspond to the first measure of each file of the
    SP_ephemerides. Currently, only the semi major axis, inclination and
    eccentricity are displayed.
    <br />
  </div>
</template>

<script>
export default {
  name: 'tooltipPlots'
}
</script>
